exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._2E--KoJqbPsPTFNbEdXz2y .ms-Dialog-action,html[dir] ._2E--KoJqbPsPTFNbEdXz2y .ms-Dialog-actionsRight{margin:initial}._2E--KoJqbPsPTFNbEdXz2y ._2yuVMd_4TXbou8DycF_FD1{width:100%}html[dir] ._2E--KoJqbPsPTFNbEdXz2y ._2yuVMd_4TXbou8DycF_FD1{margin:10px 0}", ""]);

// exports
exports.locals = {
	"dialog": "_2E--KoJqbPsPTFNbEdXz2y",
	"footerButton": "_2yuVMd_4TXbou8DycF_FD1"
};